module.exports = __webpack_public_path__ + "img/dialogGreen.32d02ac4.png";